import React from 'react';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const ContactUs = loadable(() => import(/* webpackChunkName: "ContactUs" */ './ContactUs'), {
  fallback: <LoadableFallback visible />,
});

const asyncContactUs = () => (
  <ContactUs />
);

export default asyncContactUs;
